import * as urls from "../../utils/urls";
import api from "../../services";

import axios from "axios";

import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";

import format from "date-fns/format";
import { getUserData } from "../../utils/localStorage";
import { getDoctorDetails } from "./physicianOnboardingActions";

import * as actionTypes from "./actionTypes";
import { getPatientDetails } from ".";
import { errorMessage } from "../../utils/validation/errorMessage";

let doseSpotPhysicianId = process.env.REACT_APP_DOSESPOT_DOCTOR;
let doseSpotPatientId = process.env.REACT_APP_DOSESPOT_PATIENT;
let doseSpotClinicId = process.env.REACT_APP_DOSESPOT_CLINIC_ID;
let doseSpotSubscriptionKey = process.env.REACT_APP_DOSESPOT_SUBSCRIPTION_KEY
let doseSpotClientSecret = process.env.REACT_APP_DOSESPOT_CLIENT_SECRET
let doseSpotClientId = process.env.REACT_APP_DOSESPOT_CLIENT_ID
let doseSpotClinicianID = process.env.REACT_APP_DOSESPOT_CLINICIAN_ID


export const getSSOURL = (
  userId = doseSpotPhysicianId,
  cb = () => { },
  patientId = null
) => {
  return dispatch => {
    dispatch(apiStart());

    const payload = {
      user_id: parseInt(userId),
      patient_id: parseInt(patientId),
      is_patient: !!patientId,
    };

    api
      .getSSOURL(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res.data[0]);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("Debug error sso url: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const getSSOURLPatient = (
  userId = doseSpotPatientId,
  patientId = null,
  cb = () => { }
) => {
  return dispatch => {
    dispatch(apiStart());

    const payload = {
      user_id: parseInt(userId),
      patient_id: parseInt(patientId),
      is_patient: !!patientId,
    };

    api
      .getSSOURL(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res.data[0]);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("Debug error sso url: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const getAccessToken = (
  user_id,
  cb = () => { }
) => {
  return dispatch => {
    dispatch(apiStart());

    const params = new URLSearchParams();
    params.append("grant_type", "password");
    params.append("client_id", doseSpotClientId);
    params.append("client_secret", doseSpotClientSecret);
    params.append("username", user_id || doseSpotClinicianID);
    params.append("password", doseSpotClientSecret);
    params.append("scope", "api");

    axios
      .create()
      .post(urls.getAccessToken(), params, {
        withCredentials: false,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Credentials": true,
          "Subscription-Key": doseSpotSubscriptionKey
        },
      })
      .then(response => {
        if (response.status === 200) {
          cb(response.data);
        } else {
          errorHandler("Error occured while creating token");
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("Debug error access token: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const createClinicianProfile = () => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const personalInfo = getState()?.onboarding?.personalInfo;
    const practiceDetails = getState()?.onboarding?.practiceDetails;
    const documents = getState()?.onboarding?.documents;

    dispatch(
      getAccessToken(
        null,
        data => {
          const params = new URLSearchParams();
          params.append("FirstName", personalInfo?.firstName);
          params.append("LastName", personalInfo?.lastName);
          params.append(
            "DateOfBirth",
            format(personalInfo?.date_of_birth, "MM/dd/yyyy")
          );
          params.append("Address1", practiceDetails?.address1);
          params.append("City", practiceDetails?.city);
          params.append("State", practiceDetails?.state);
          params.append("ZipCode", practiceDetails?.zipcode);
          params.append("PrimaryPhone", practiceDetails?.primaryPhone);
          params.append(
            "PrimaryPhoneType",
            practiceDetails?.primaryPhoneType?.value
          );
          params.append("PrimaryFax", practiceDetails?.primaryFax);
          params.append("DEANumbers[0][DEANumber]", documents?.deaNumber);
          params.append("DEANumbers[0][State]", documents?.deaState?.value);
          params.append("NPINumber", documents?.npiNumber);
          params.append("ClinicianRoleType", "1");
          params.append("Active", "True");

          axios
            .create()
            .post(urls.addClinician(), params, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Credentials": true,
                "Subscription-Key": doseSpotSubscriptionKey,
                Authorization: `Bearer ${data.access_token}`,
              },
            })
            .then(response => {
              if (response.status === 200) {
                const data = response.data;

                if (data?.Result?.ResultCode === "ERROR") {
                  errorHandler(data?.Result?.ResultDescription);
                } else {
                  successHandler("DoseSpot profile created");

                  const payload = { dosespot_id: response?.data?.Id };

                  api
                    .addDoctorDoseSpotID(getUserData()?.id, payload)
                    .then(response => {
                      const res = response.data;
                      if (res.status_code === 200) {
                        successHandler("DoseSpot profile registered");

                        dispatch(getDoctorDetails());
                      } else {
                        errorHandler(res.message[0]);
                      }
                    })
                    .catch(error => {
                      catchHandler(error, dispatch);
                    });
                }
              } else {
                console.log(
                  "Debug Failed - Create Clinician then block:: ",
                  response
                );
                errorHandler(errorMessage.creatingProfileError + "clinician.");
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              if (error.response.status === 400) {
                const data = error?.response?.data;

                data &&
                  errorHandler(
                    Object.keys(data.ModelState)
                      .map(key => data.ModelState[key])
                      .join(", ")
                  );
              }
              console.log(errorMessage.createProfileDebugError, error);
              catchHandler(error, dispatch);
            });
        }
      )
    );
  };
};

export const getAccessTokenPatient = (
  user_id,
  encrypted_patient_id,
  cb = () => { }
) => {
  return dispatch => {
    dispatch(apiStart());

    const params = new URLSearchParams();
    params.append("grant_type", "password");
    params.append("client_id", doseSpotClientId);
    params.append("client_secret", doseSpotClientSecret);
    params.append("username", doseSpotPatientId);
    params.append("password", doseSpotClientSecret);
    params.append("scope", "api");

    axios
      .create()
      .post(urls.getAccessToken(), params, {
        withCredentials: false,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Credentials": true,
          "Subscription-Key": doseSpotSubscriptionKey
        },
        auth: {
          username: doseSpotClinicId,
          password: encrypted_patient_id,
        },
      })
      .then(response => {
        if (response.status === 200) {
          cb(response.data);
        } else {
          errorHandler("Error occured while creating token");
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("Debug error access token: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const createPatientDoseSpotProfile = () => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    const patientPersonalInfo = getState()?.onboarding?.patientPersonalInfo;

    dispatch(
      getAccessTokenPatient(
        doseSpotPatientId,
        null,
        data => {
          const params = new URLSearchParams();
          let gender = 3;
          if (
            patientPersonalInfo.gender &&
            patientPersonalInfo.gender === "FEMALE"
          ) {
            gender = 2;
          } else if (
            patientPersonalInfo.gender &&
            patientPersonalInfo.gender === "MALE"
          ) {
            gender = 1;
          }
          let height = patientPersonalInfo?.height
            ? parseInt(patientPersonalInfo.current_feets * 12) +
            parseInt(patientPersonalInfo.current_inches)
            : 0;

          params.append("FirstName", patientPersonalInfo?.firstName);
          params.append("LastName", patientPersonalInfo?.lastName);
          params.append(
            "DateOfBirth",
            format(patientPersonalInfo?.date_of_birth, "yyyy/MM/dd")
          );
          params.append("Gender", gender);
          params.append("Address1", patientPersonalInfo?.address1);
          params.append("City", patientPersonalInfo?.city);
          params.append("State", patientPersonalInfo?.state);
          params.append("ZipCode", patientPersonalInfo?.zipcode);
          params.append("PrimaryPhone", patientPersonalInfo?.primary_phone);
          params.append(
            "PrimaryPhoneType",
            patientPersonalInfo?.primaryPhoneType?.value
          );
          params.append("Active", "True");
          params.append("Height", height);
          params.append("HeightMetric", 1);
          params.append("Weight", patientPersonalInfo?.weight);
          params.append("WeightMetric", 1);

          axios
            .create()
            .post(urls.addPatient(), params, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Credentials": true,
                "Subscription-Key": doseSpotSubscriptionKey,
                Authorization: `Bearer ${data.access_token}`,
              },
            })
            .then(response => {
              if (response.status === 200) {
                const data = response.data;

                if (data?.Result?.ResultCode === "ERROR") {
                  errorHandler(data?.Result?.ResultDescription);
                } else {
                  successHandler("e-Prescription profile created patient");

                  const payload = { dosespot_id: response?.data?.Id };

                  api
                    .addPatientDoseSpotID(getUserData()?.id, payload)
                    .then(response => {
                      const res = response.data;
                      if (res.status_code === 200) {
                        successHandler(
                          "e-Prescription profile registered patient"
                        );

                        dispatch(getPatientDetails());
                      } else {
                        errorHandler(res.message[0]);
                      }
                    })
                    .catch(error => {
                      console.log("Debug error add patient: ", error);

                      catchHandler(error, dispatch);
                    });
                }
              } else {
                errorHandler("Error occured while creating patient");
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              if (error.response.status === 400) {
                const data = error?.response?.data;

                data &&
                  errorHandler(
                    Object.keys(data.ModelState)
                      .map(key => data.ModelState[key])
                      .join(", ")
                  );
              }
              console.log("Debug error create profile patient: ", error);
              catchHandler(error, dispatch);
            });
        }
      )
    );

  };
};

export const updateClinicianProfile = clinicianId => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const personalInfo = getState()?.onboarding?.personalInfo;
    const practiceDetails = getState()?.onboarding?.practiceDetails;
    const documents = getState()?.onboarding?.documents;

    dispatch(
          getAccessToken(
            null,
            data => {
              const params = new URLSearchParams();
              params.append("FirstName", personalInfo?.firstName);
              params.append("LastName", personalInfo?.lastName);
              params.append(
                "DateOfBirth",
                format(personalInfo?.date_of_birth, "MM/dd/yyyy")
              );
              params.append("Address1", practiceDetails?.address1);
              params.append("City", practiceDetails?.city);
              params.append("State", practiceDetails?.state);
              params.append("ZipCode", practiceDetails?.zipcode);
              params.append("PrimaryPhone", practiceDetails?.primaryPhone);
              params.append(
                "PrimaryPhoneType",
                practiceDetails?.primaryPhoneType?.value
              );
              params.append("PrimaryFax", practiceDetails?.primaryFax);
              params.append("DEANumbers[0][DEANumber]", documents?.deaNumber);
              params.append("DEANumbers[0][State]", documents?.deaState?.value);
              params.append("NPINumber", documents?.npiNumber);
              params.append("ClinicianRoleType", "1");
              params.append("Active", "True");

              axios
                .create()
                .put(urls.editClinician(clinicianId), params, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Access-Control-Allow-Credentials": true,
                    "Subscription-Key": doseSpotSubscriptionKey,
                    Authorization: `Bearer ${data.access_token}`,
                  },
                })
                .then(response => {
                  if (response.status === 200) {
                    const data = response.data;

                    if (data?.Result?.ResultCode === "ERROR") {
                      errorHandler(data?.Result?.ResultDescription);
                    } else {
                      successHandler("DoseSpot profile updated");
                      dispatch(getDoctorDetails());
                    }
                  } else {
                    console.log(
                      "Debug Failed - Update Clinician then block:: ",
                      response
                    );
                    errorHandler("Error occured while creating clinician");
                  }
                  dispatch(apiSuccess());
                })
                .catch(error => {
                  if (error.response.status === 400) {
                    const data = error?.response?.data;

                    data &&
                      errorHandler(
                        Object.keys(data.ModelState)
                          .map(key => data.ModelState[key])
                          .join(", ")
                      );
                  }

                  console.log("Debug error Update profile: ", error);
                  catchHandler(error, dispatch);
                });
            }
          )
    );
  };
};

export const updatePatientDoseSpotProfile = patientDosespotId => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const patientPersonalInfo = getState()?.onboarding?.patientPersonalInfo;

    dispatch(
      getSSOURLPatient(doseSpotPatientId, patientDosespotId, data => {
        dispatch(
          getAccessTokenPatient(
            doseSpotPatientId,
            data.encrypted_user,
            data.encrypted_clinic,
            data => {
              const params = new URLSearchParams();
              let gender = 3;
              if (
                patientPersonalInfo.gender &&
                patientPersonalInfo.gender === "FEMALE"
              ) {
                gender = 2;
              } else if (
                patientPersonalInfo.gender &&
                patientPersonalInfo.gender === "MALE"
              ) {
                gender = 1;
              }
              let height = patientPersonalInfo?.height
                ? parseInt(patientPersonalInfo.current_feets * 12) +
                parseInt(patientPersonalInfo.current_inches)
                : 0;
              params.append("FirstName", patientPersonalInfo?.firstName);
              params.append("LastName", patientPersonalInfo?.lastName);
              params.append(
                "DateOfBirth",
                format(patientPersonalInfo?.date_of_birth, "yyyy/MM/dd")
              );
              params.append("Gender", gender);
              params.append("Address1", patientPersonalInfo?.address1);
              params.append("City", patientPersonalInfo?.city);
              params.append("State", patientPersonalInfo?.state);
              params.append("ZipCode", patientPersonalInfo?.zipcode);
              params.append("PrimaryPhone", patientPersonalInfo?.primary_phone);
              params.append(
                "PrimaryPhoneType",
                patientPersonalInfo?.primaryPhoneType?.value
              );
              params.append("Active", "True");
              params.append("Height", height);
              params.append("HeightMetric", 1);
              params.append("Weight", patientPersonalInfo?.weight);
              params.append("WeightMetric", 1);

              axios
                .create()
                .post(urls.editPatientDosespot(patientDosespotId), params, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Access-Control-Allow-Credentials": true,
                    Authorization: `Bearer ${data.access_token}`,
                  },
                })
                .then(response => {
                  if (response.status === 200) {
                    const data = response.data;

                    if (data?.Result?.ResultCode === "ERROR") {
                      errorHandler(data?.Result?.ResultDescription);
                    } else {
                      successHandler("e-Prescription profile updated");
                      dispatch(getPatientDetails());
                    }
                  } else {
                    console.log("Debug Failed - Update patient :: ", response);
                    errorHandler("Error occured while updating patient");
                  }
                  dispatch(apiSuccess());
                })
                .catch(error => {
                  if (error.response.status === 400) {
                    const data = error?.response?.data;

                    data &&
                      errorHandler(
                        Object.keys(data.ModelState)
                          .map(key => data.ModelState[key])
                          .join(", ")
                      );
                  }

                  console.log("Debug error Update profile: ", error);
                  catchHandler(error, dispatch);
                });
            }
          )
        );
      })
    );
  };
};

export const setPatientPrescriptions = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_PATIENT_PRESCRIPTIONS,
      payload,
    });
  };
};

export const getPatientPrescriptions = (
  patient_id,
  startDate,
  endDate,
  cb = () => { }
) => {
  return dispatch => {
    dispatch(apiStart());

    const doctor_dosespot_id = getUserData()?.dosespot_id;

    dispatch(
      getSSOURL(
        doctor_dosespot_id,
        data => {
          dispatch(
            getAccessToken(
              doctor_dosespot_id,
              data => {
                axios
                  .create()
                  .get(
                    urls.getPatientPrescriptions(
                      patient_id,
                      format(startDate, "MM-dd-yyyy"),
                      format(endDate, "MM-dd-yyyy")
                    ),
                    {
                      headers: {
                        Authorization: `Bearer ${data?.access_token}`,
                        "Subscription-Key": doseSpotSubscriptionKey
                      },
                    }
                  )
                  .then(response => {
                    console.log("PRESCRIPTION RESPONSE <<>>", response)
                    if (response.status === 200) {
                      const data = response.data;

                      if (data?.Result?.ResultCode === "ERROR") {
                        errorHandler(data?.Result?.ResultDescription);
                      } else {
                        const prescriptions = response?.data?.Items;

                        const prescribersId = prescriptions.map(
                          prescription => prescription?.PrescriberId
                        );

                        const payload = {
                          dosespot_ids: prescribersId,
                        };

                        api
                          .getDoctorByDoseSpotID(payload)
                          .then(response => {
                            const res = response.data;
                            if (res.status_code === 200) {
                              const doctorInfo = res.data;

                              const updatedPrescriptions = prescriptions.map(
                                prescription => {
                                  const prescriptionObj = doctorInfo.find(
                                    info =>
                                      parseInt(info.dosespot_id) ===
                                      prescription?.PrescriberId
                                  );

                                  return {
                                    ...prescription,
                                    PrescriberFirstName:
                                      prescriptionObj?.first_name,
                                    PrescriberLastName:
                                      prescriptionObj?.last_name,
                                    PrescriberSignature:
                                      prescriptionObj?.signature,
                                    PrescriberDegree:
                                      prescriptionObj?.degree[0]?.degree,
                                  };
                                }
                              );

                              const sortedPrescriptions =
                                updatedPrescriptions?.sort((a, b) =>
                                  new Date(a?.WrittenDate) <
                                    new Date(b?.WrittenDate)
                                    ? 1
                                    : -1
                                );

                              dispatch(
                                setPatientPrescriptions({
                                  allPrescriptions: sortedPrescriptions,
                                })
                              );
                            } else {
                              errorHandler(res.message[0]);
                            }
                            dispatch(apiSuccess());
                          })
                          .catch(error => {
                            console.log("Debug error sso url: ", error);
                            catchHandler(error, dispatch);
                          });

                        cb(response?.data?.Items);
                      }
                    }
                    dispatch(apiSuccess());
                  })
                  .catch(error => {
                    console.log("Debug error access token: ", error);
                    catchHandler(error, dispatch);
                  });
              }
            )
          );
        },
        patient_id
      )
    );
  };
};

export const searchPatientPrescriptions = q => {
  return (dispatch, getState) => {
    const prescriptions = getState()?.dashboard?.patients?.allPrescriptions;

    if (prescriptions?.length > 0) {
      const searchPrescriptions = prescriptions.filter(x => {
        const prescriptionName = x?.DisplayName;

        return (
          prescriptionName?.toLowerCase()?.includes(q.toLowerCase()) ||
          x.PrescriberFirstName?.toLowerCase()?.includes(q?.toLowerCase()) ||
          x.PrescriberLastName?.toLowerCase()?.includes(q?.toLowerCase())
        );
      });

      dispatch({
        type: actionTypes.SEARCH_PATIENT_PRESCRIPTIONS,
        searchValue: q,
        search: searchPrescriptions,
      });
    }
  };
};

export const emptyPatientPrescriptions = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_PATIENT_PRESCRIPTIONS,
    });
  };
};
